// Endpoint
export const SchoolEndPoint = {
  GET: 'admin/school/list',
  CREATE: 'admin/school/create',
  DETAIL: 'admin/school/by-id',
  UPDATE: 'admin/school/update',
  DELETE: 'admin/school/delete',
  TOTAL: 'admin/school/count',
}
